module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/liver-5cede02ad85d16e99213b1f4c63ae042.png";